import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hidden", "footer"];

  connect() {
    this.batchSize = 9;
    this.currentIndex = 0;
    this.hiddenTargets.forEach((card) => (card.style.display = "none"));
  }

  loadMore() {
    const batch = this.hiddenTargets.slice(
      this.currentIndex,
      this.currentIndex + this.batchSize,
    );
    batch.forEach((card) => (card.style.display = ""));
    this.currentIndex += batch.length;

    if (this.currentIndex >= this.hiddenTargets.length) {
      this.footerTarget.style.display = "none";
    }
  }
}
